<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide(){
    return{
        reload:this.reload
    };
  },
  data(){
    return{
        isRouterAlive:true
    };
  },
  created(){
    // let loading = document.getElementById("loadings")
    // try{
    //   setTimeout(function() {
    //     document.body.removeChild(loading);
    //   }, 1000)
    // }catch (e) {
    //   console.log(e)
    // }
    // if(loading != null){
    //   document.body.removeChild(loading);
    // }
  },
  methods:{
    reload(){
        this.isRouterAlive = false;
        this.$nextTick(function(){
            this.isRouterAlive = true;
        })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/App.vue